interface ViewToggleProps {
  mode: 'table' | 'cards';
  onChange: (mode: 'table' | 'cards') => void;
}

/**
 * Two icon buttons to switch between table and card grid views.
 */
export function ViewToggle({ mode, onChange }: ViewToggleProps) {
  return (
    <div class="view-toggle">
      <button
        class={`view-toggle-btn${mode === 'table' ? ' active' : ''}`}
        onClick={() => onChange('table')}
        title="Table view"
        type="button"
      >
        {/* List icon */}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
      </button>
      <button
        class={`view-toggle-btn${mode === 'cards' ? ' active' : ''}`}
        onClick={() => onChange('cards')}
        title="Card view"
        type="button"
      >
        {/* Grid icon */}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
        </svg>
      </button>
    </div>
  );
}
